
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../../../main/components/nav-left/nav-left.vue";
import TemplateTransform from "../template-transform/template-transform.vue";
import {
  TemplateGroupDetail,
  TemplateDetail,
  saveContent,
  zhenciDetail,
  contentDetail,
} from "@/request/doctor";
@Component({
  components: {
    MainHeader,
    NavLeft,
    TemplateTransform,
  },
})
export default class Name extends Vue {
  private zhenci_id: any;
  private ifCompose: any = true;
  private H: any = 0;
  private time: any;
  private type: any = "";
  private disabledDate: any = this.beginDate();
  private navData: any = {
    templates: {
      基本信息类: [],
      实验室检查类: [],
      健康测评类: [],
    },
  };
  private navs: any = ["基本信息类", "实验室检查类", "健康测评类"];
  private cNav: any = "基本信息类";
  private cPart: any = {};
  private templates: any = [];
  private content: any = {};
  private bitianMsg: any = [];
  private beginDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private get user() {
    return this.$store.state.user;
  }
  private changeTab(item: any) {
    console.log(item);
    this.cPart = item;
    this.ifCompose = false;
    this.getTemplates();
  }
  private getNavData() {
    const params = {
      zhenci_id: this.zhenci_id,
    };
    zhenciDetail(this, params).then((res: any) => {
      this.navData = res;
      if (this.cPart.template_id && !this.cPart.content_id) {
        // 存在表示是新建保存是调，需要置入content_id
        res.templates[this.cNav].forEach((ele: any) => {
          if (ele.template_id === this.cPart.template_id) {
            this.cPart = ele;
          }
        });
        // 刷新量表数据
        this.getTemplates();
      }
    });
  }
  private getTemplates() {
    if (this.cPart.content_id) {
      const params = {
        content_id: this.cPart.content_id,
      };
      contentDetail(this, params).then((res: any) => {
        this.content = res;
        this.templates = res.data;
      });
    } else {
      const params = {
        template_id: this.cPart.template_id,
      };
      TemplateDetail(this, params).then((res: any) => {
        this.content = res;
        this.templates = res["模板"];
      });
    }
  }
  private updateTemplate(item: any) {
    this.templates[item.index] = item.data;
  }
  private createTipMes() {
    if (!this.templates && this.templates.length === 0) {
      return;
    }
    this.bitianMsg = [];
    this.templates.forEach((ele: any, i: any) => {
      if (ele.is_required) {
        this.bitianMsg.push({
          required: false,
          tipMsg: ele.title + "为必填题！",
        });
      } else {
        this.bitianMsg.push({
          required: false,
          tipMsg: "",
        });
      }
    });
  }
  private save() {
    console.log(this.templates);
    this.createTipMes();
    for (let i = 0; i < this.templates.length; i++) {
      if (this.templates[i].is_required) {
        let weitian = true;
        if (this.templates[i].type === "多选") {
          weitian = this.templates[i].value.length === 0;
        } else if (
          this.templates[i].type === "多选补充文字" ||
          this.templates[i].type === "单选补充文字"
        ) {
          let val = true;
          for (const opt of this.templates[i]["options"]) {
            if (opt.value) {
              val = false;
            }
          }
          weitian = val;
        } else {
          weitian = !this.templates[i].value;
        }
        if (weitian) {
          // 没填的标红
          this.bitianMsg[i].required = true;
          // 弹提示哪个未填
          this.$message.error(this.bitianMsg[i].tipMsg);
          // 滚动到没填的题目
          const parent = (document as any).getElementById("menzhen-edit-right");
          const child = (document as any).getElementById("liangbiao" + i);
          parent.scrollTop = child.offsetTop - parent.offsetTop - 2;
          return;
        } else {
          this.bitianMsg[i].required = false;
        }
      }
    }
    let data: any = this.content;
    data.data = this.templates;
    data.zhenci_id = this.zhenci_id;
    data.patient_id = this.patient.patient_id;
    if (!data["采集时间"]) {
      data["采集时间"] = this.patient.create_time;
    }
    console.log(data);
    saveContent(this, data).then((res: any) => {
      this.$message.success("保存成功")!;
      this.ifCompose = false;
      this.getNavData();
      this.getTemplates();
    });
  }
  /**
   * @description 隐藏或者显示某些相关题目
   */
  private changeHide(e: any) {
    let arr: any = [];
    if (e.control.index.length === 0) {
      // 循环改值
      e.control.all.forEach((ele: any) => {
        const index = this.templates.findIndex((val: any) => {
          return ele === val.id;
        });
        this.$set(this.templates[index], "hide", !e.control.hide);
        // 如果是隐藏需要清除值
        if (!e.control.hide) {
          this.clearVal(this.templates[index]);
        }
      });
    } else {
      // 拼接数组
      e.control.index.forEach((ele: any) => {
        arr = arr.concat(e.control.list[ele]);
      });
      // 去重
      arr = Array.from(new Set(arr));
      e.control.all.forEach((ele: any) => {
        const index = this.templates.findIndex((val: any) => {
          return ele === val.id;
        });
        const i = arr.findIndex((val: any) => {
          return ele === val;
        });
        if (i === -1) {
          // 找不到给hide相反的值
          this.$set(this.templates[index], "hide", !e.control.hide);
          // 如果是隐藏需要清除值
          if (!e.control.hide) {
            this.clearVal(this.templates[index]);
          }
        } else {
          // 找到给hide的值
          this.$set(this.templates[index], "hide", e.control.hide);
          // 如果是隐藏需要清除值
          if (e.control.hide) {
            this.clearVal(this.templates[index]);
          }
        }
      });
    }
  }
  /**
   * @description 清除隐藏题目的value
   */
  private clearVal(item: any) {
    if (item.type === "计分单选" || item.type === "sf36计分单选") {
      item.value = {};
    } else if (item.type === "单选补充文字" || item.type === "多选补充文字") {
      item.options.forEach((ele: any) => {
        ele.value = false;
        if (ele.content) {
          ele.content = "";
        }
        if (ele.extra) {
          ele.extra.forEach((ext: any) => {
            if (ext.type === "多选") {
              ext.value = [];
            } else {
              ext.value = "";
            }
          });
        }
      });
    } else if (item.type === "多选") {
      item.value = [];
    } else {
      item.value = "";
    }
  }
  private mounted() {
    this.H = document.body.clientHeight - 78 - 40 - 14;
    if (this.$route.query.zhenci_id) {
      this.zhenci_id = this.$route.query.zhenci_id;
      if (this.$route.query.type) {
        this.ifCompose = false;
      }
      this.getNavData();
    }
    // const data = JSON.parse(this.$route.query.data as any);
    // console.log('data')
    // console.log(data);
    // this.type = data.type;
    if (this.type === "add") {
      this.ifCompose = true;
    }
    // this.getTemplates();
  }
}
